<template>
    <div v-if="job" class="card">
        <div class="container-fluid p-3">
          <b-row>
            <div class="col-xl-6 ml-auto mr-auto">
              <b-card no-body>
                <b-card-header size="sm">
                  <div class="d-flex justify-content-between align-items-start">
                    <h2>{{ job.name ? job.name : 'No Name'}}</h2>
                    <div>
                      <badge :type="job | snapshotStatusDescription | badgeTypeForStatusDescription" class="mx-2">
                        {{job | snapshotStatusDescription}}
                      </badge>

                      <b-button v-b-popover.hover.bottom="'Add to cart'"  variant="outline-primary" class="mx-2  img-icon img-icon-cart-add-9" size="sm"
                            @click="addToCart(job)" v-if="!addedInCart"></b-button>
                      <b-button v-b-popover.hover.bottom="'Remove from cart'"  variant="outline-danger" class="mx-2  img-icon img-icon-cart-remove-9" size="sm"
                            @click="removeFromCart(job)" v-if="addedInCart"></b-button>
                      <b-button size="sm" variant="outline-danger" class="mx-2" @click="deleteThisJob()">X</b-button>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-start">
                    <div>
                      <div><small>{{ job.bytes | bytes }}</small></div>
                      <div><small>{{ $moment(job.dateStarted).calendar() }}</small></div>
                    </div>
                    <div class="mt-auto">
                      <report-button-set :jobItem="job"></report-button-set>
                    </div>
                  </div>
                </b-card-header>

                <div v-if="jobIsComplete">
                  <file-search-card :job-id="jobId" class="m-0"></file-search-card>
                </div>
                <div v-else-if="jobIsLive">
                  <live-job-card  :job-id="jobId" :include-header="false" class="m-0"></live-job-card>
                </div>
                <div v-else class="text-center p-3 h-fixed">
                  No File Details Available
                </div>

                <b-card-footer>
                  <vue-tags-input
                    input-id="job-detail-tags"
                    v-model="tag"
                    :tags="tags"
                    @before-adding-tag="beforeTagAdd"
                    @before-deleting-tag="beforeTagDelete"
                  />
                </b-card-footer>
              </b-card>

              <comment-card :jobId=jobId class="mt-5"></comment-card>
            </div>

<!--            <div class="col-xl-3">-->
<!--              <notes-card></notes-card>-->
<!--            </div>-->
          </b-row>
        </div>
    </div>
</template>

<script>
import { VueTagsInput, createTag } from '@johmun/vue-tags-input';
import CommentCard from '#/ui/Components/CommentCard.vue';
import ReportButtonSet from '#/ui/Components/ReportButtonSet.vue';
import LiveJobCard from '#/ui/Components/Live/LiveJobCard.vue';
import FileSearchCard from '#/ui/Components/FileSearchCard.vue';

import { DeleteJobRequest } from '#/protobuf/service_deletion_pb';
import { JobTagUpdateRequest } from '#/protobuf/service_modification_pb';
import { JobGetSession } from '#/services/jobs';
import { jobIsCompletedSuccessfully } from '#/models/jobs/job';

export default {
  components: {
    LiveJobCard,
    CommentCard,
    VueTagsInput,
    ReportButtonSet,
    FileSearchCard,
  },
  data() {
    const { jobId } = this.$route.params;
    return {
      session: new JobGetSession(jobId),
      tag: '',
      tags: [],
    };
  },
  created() {
    return this.session.load().then(() => {
      this.session.job.expandedTagsList.forEach((tag) => {
        const obj = createTag(tag.tag, this.tags);
        this.tags.push(obj);
      });
    });
  },
  computed: {
    addedInCart() {
      return this.$store.getters['datacart/cartItems'].filter((item) => item.id === this.jobId).length === 1;
    },
    jobId() {
      return this.$route.params.jobId;
    },
    job() {
      return this.session.job;
    },
    jobIsComplete() {
      // has the job completed with no errors
      return jobIsCompletedSuccessfully(this.session.job);
    },
    jobIsLive() {
      // if the job is not complete and we have live data
      return !this.jobIsComplete && this.$store.getters['live/snapshotById'](this.jobId) !== undefined;
    },
  },
  methods: {
    disableCart(id) {
      return this.$store.getters['datacart/cartItems'].filter((item) => item.id === id).length === 1;
    },
    beforeTagAdd(obj) {
      const tag = [obj.tag.text];
      const request = new JobTagUpdateRequest();
      request.setJobId(this.jobId);
      request.setTagsToAddList(tag);
      this.$store.dispatch('jobs/updateTags', request).then((response) => {
        obj.addTag();
      }).catch((error) => {
        alert('Error adding tag', error);
      });
    },
    beforeTagDelete(obj) {
      const tag = [obj.tag.text];
      const request = new JobTagUpdateRequest();
      request.setJobId(this.jobId);
      request.setTagsToRemoveList(tag);
      this.$store.dispatch('jobs/updateTags', request).then((response) => {
        obj.deleteTag();
      }).catch((error) => {
        alert('Error removing tag', error);
      });
    },
    deleteThisJob() {
      this.$bvModal.msgBoxConfirm('Do you really want to delete this record? This cannot be undone.', {
        title: 'Remove Record',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'DELETE',
        cancelTitle: 'NO',
        headerClass: 'align-items-center',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then((userAcceptedDelete) => {
        if (userAcceptedDelete) {
          const req = new DeleteJobRequest();
          req.setJobidsList([this.jobId]); // TODO: Why is the i not capitalized in Jobids here???
          this.$store.dispatch('jobs/delete', req).then(() => {
            this.$router.push({ path: '/home/', project: this.$route.params.project });
          }).catch(() => {
          });
        }
      }).catch(() => {
      });
    },
    addToCart(job) {
      this.$store.dispatch('datacart/addToCart', job);
      this.addedInCart = true;
    },
    removeFromCart(job) {
      this.$store.dispatch('datacart/removeFromCart', { id: job.jobId });
      this.addedInCart = false;
    },
  },
};
</script>

<style lang="scss">
.vue-tags-input {
  max-width: 100% !important;
}
</style>
